import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'ppe_related_potassium_permanganate_pp_good_condition_regularly'

export const dataPointDefinition = {
  retracedId: 'ppe_related_potassium_permanganate_pp_good_condition_regularly',
  name: 'Is the PPE related to Potassium Permanganate (PP) in good condition and regularly replaced as per their defined duration',
  description: '"Defined duration of use" means the duration of use as per manufacturing instructions.',
  meta: {
    slcpMeta: {
      key: 'hs-wor-27',
      number: 'HS-WOR-10',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: 'yes-no',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-wor-26,Yes',
      machineShowHide: '[2],hs-wor-26,1',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'yes_no',
      name: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['yes_no'],
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-wor-27', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31710,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
